module.exports = __webpack_public_path__ + "img/70_43.914492d9.png";